import {
  TextField,
  Button,
  Typography,
  Alert,
  Paper,
  Box,
} from '@mui/material';
import { useFormik } from 'formik';
import { toValidator } from 'renderer/shared/schemas/common.schemas';
import { formatQueryError } from 'renderer/shared/formatters/formatters';
import { useAppSelector } from 'renderer/shared/state/hooks';
import { useResetPasswordMutation } from '../services/auth.endpoints';
import {
  ResetPasswordFormSchema,
  ResetPasswordRequest,
} from '../schemas/auth.schemas';
import { selectUser } from '../state/userSelectors';

const ForgotPassword = () => {
  const user = useAppSelector(selectUser);
  const initialEmail = user.role === 'public' ? '' : user.email;

  const [resetPassword, { data: result, isSuccess, error, isLoading }] =
    useResetPasswordMutation();
  const { values, touched, errors, handleBlur, handleChange, handleSubmit } =
    useFormik<ResetPasswordRequest>({
      initialValues: { email: initialEmail },
      validate: toValidator(ResetPasswordFormSchema),
      onSubmit: (form) => {
        resetPassword(form);
      },
    });

  return (
    <Box sx={{ py: 5, display: 'flex', justifyContent: 'center' }}>
      <Paper elevation={3} sx={{ p: 4, maxWidth: 400, width: '100%' }}>
        <Typography variant="h5" gutterBottom fontWeight="bold">
          Reset Password
        </Typography>
        <Typography variant="body2" sx={{ mb: 3, color: 'text.secondary' }}>
          Enter your email to receive a reset link
        </Typography>
        {isSuccess && result && (
          <Alert severity="success" sx={{ mb: 2 }}>
            {result.message}
          </Alert>
        )}
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {formatQueryError(error)}
          </Alert>
        )}
        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            size="small"
            required
            id="email"
            name="email"
            label="Email"
            type="email"
            sx={{ mb: 2 }}
            disabled={isLoading || user.role !== 'public'}
            value={values.email}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.email && !!errors.email}
            helperText={touched.email && errors.email}
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            disabled={isLoading}
            sx={{ py: 1.3 }}
          >
            Reset Password
          </Button>
        </form>
      </Paper>
    </Box>
  );
};

export default ForgotPassword;
